module.exports = __webpack_public_path__ + "static/media/vippsinput.53f30439.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Signup/Media/vippsinput.PNG
// module id = 216
// module chunks = 0